export const FEATURE_NAME = "plp-search-ai";
export const COOKIE_NAME = "mvt-query-params";
